<template>
  <div class="footbox">
    <div class="footer">
      <div class="footerbox">
        <div class="footerleft">
          <p v-html="hfliat.copyright" v-show="hfliat.copyright"></p>
          <p v-html="hfliat.record" v-show="hfliat.record"></p>
          <p v-html="hfliat.phone" v-show="hfliat.phone"></p>
        </div>
        <div class="footerrig">
          <ul>
            <li v-show="hfliat.qrCode1">
              <img :src="hfliat.qrCode1" style="width: 90px; height: 90px" alt="" />
              <p>{{hfliat.text1}}</p>
            </li>
            <li v-show="hfliat.qrCode2">
              <img :src="hfliat.qrCode2" style="width: 90px; height: 90px" alt="" />
              <p>{{hfliat.text2}}</p>
            </li>
            <li v-show="hfliat.qrCode3">
              <img :src="hfliat.qrCode3" style="width: 90px; height: 90px" alt="" />
              <p>{{hfliat.text3}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript"></script>
<script>
import { detail } from "@/api/index.js";
export default {
  name: "footbox",
  data() {
    return {
      hfliat: [],
    };
  },
  created() {
    this.handleheadfoot();
  },
  methods: {
    // 头部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
        // this.hfliat.record = ''
        console.log(1212,this.hfliat);
      });
    },
  },
};
</script>
<style lang="less">
.footer {
  background: #2c2c2c;
  @media screen and (max-width: 920px) {
    background: #f5f5f5;
  }
}
.footerbox {
  max-width: 1200px;
  // min-width: 350px;
  margin: 0 auto;
  display: flex;
  font-size: 12px;
  color: #fff;
}
.footerleft {
  flex: 7;
  font-size: 18px;
  margin: 80px 0;
  text-align: left;
  padding-left: 16px;
  @media screen and (max-width: 920px) {
    text-align: center;
    padding: 30px 0;
  }
}
.footerleft > p {
  margin-bottom: 5px;
  @media screen and (max-width: 920px) {
    color: #7a7a7a;
  }
}
.footerleft > p:first-child {
  display: none;
}
.footerleft > p > a {
  color: #909090;
  font-size: 12px;
  @media screen and (max-width: 920px) {
    color: #7a7a7a;
  }
}
.footerleft > p:last-child {
  color: #909090;
  margin-bottom: 0;
  font-size: 12px;
}
.footerrig {
  flex: 3;
  text-align: left;
}
.footerrig > ul {
  margin-top: 62px;
  display: flex;
}
.footerrig > ul > li {
  margin-right: 16px;
}
.footerrig > ul > li > p {
  font-size: 10px;
  text-align: center;
}
.footerkbg {
  flex: 2;
}
@media screen and (max-width: 920px) {
  .footerbox {
    display: block;
  }
  .footerleft {
    margin: 0 !important;
  }
  .footerrig {
    display: none;
  }
  .footerrig > ul {
    margin-top: 10px;
    justify-content: center;
  }
  .footerrig {
    text-align: center;
  }
}
</style>
